import { toRem } from "shared/helpers";
import styled from "styled-components";

export const WeatherContainer = styled.div`
  display: flex;
  justify-content: center;
  padding-bottom: ${toRem(100)};
`;

export const WeatherWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${toRem(8)};
  max-width: 1040px;
  width: 100%;
`;

export const WeatherBlocks = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${toRem(8)};
`;
